<section id="intro-proyects" class="section-bg-dark">
  <div class="container-fluid">
    <div class="row">
      <div _ngcontent-fac-c9="" class="col-xs-12 pl-4">
        <h2 class="text-white">PROYECTO DE CONSULTORÍA</h2>
      </div>
    </div>
  </div>
</section>

<section id="consulting_proyect">
  <div class="container">
    <div class="row mb-3">
      <div class="col-sm-12 col-xs-12">
        <p class="font-medium">
          Servicio de consultoría en materia de marketing digital atendiendo a
          las características específicas del área de seguros, salud y dental.
        </p>
      </div>
    </div>
  </div>
  <div class="container img-claim">
    <div class="row">
      <img src="assets/img/proyect_consulting.webp">
    </div>
  </div>
  <div class="container">
    <div class="row justify-content-between">
      @for (card of cards; track card) {
      <div class="card col-sm-12 col-md-4 text-center p-2">

        <div class="card-body">
          <div class="border_box">
            <h5>{{ card.title }}</h5>
            <p>
              {{ card.text }}
            </p>
          </div>
        </div>
      </div>
      }

    </div>
  </div>


  <div class="container">
    <div class="row">
      <div class="col-xs-12 w-100 text-center mt-10">
        <h2>NUESTROS PARTNERS</h2>
      </div>
    </div>
    <br>
    <div class="carousel slide carousel-multi-item" data-ride="carousel" data-interval="1500">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <div class="row logos">
            @for (carousel of carousels.slice(0, 4); track carousel) {
            <div class="col-xs-3 col-md-3">
              <img src="{{ carousel.src }}" alt="{{ carousel.alt }}" class="icons_standar">
            </div>
            }
          </div>
        </div>

        <div class="carousel-item">
          <div class="row logos">
            @for (carousel of carousels.slice(4, 7); track carousel) {
            <div class="col-xs-3 col-md-4">
              <img src="{{ carousel.src }}" alt="{{ carousel.alt }}" class="icons_standar">
            </div>
            }
          </div>
        </div>

        <div class="carousel-item">
          <div class="row logos">
            @for (carousel of carousels.slice(7, 10); track carousel) {
            <div class="col-xs-3 col-md-4">
              <img src="{{ carousel.src }}" alt="{{ carousel.alt }}" class="icons_standar">
            </div>
            }
          </div>
        </div>

        <div class="carousel-item">
          <div class="row logos">
            <div class="col-xs-4 col-md-6">
              <img src="assets/img/linkmobility-spain.png" alt="Link Mobility" class="icons_standar-bg">
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row justify__content-center">
      <div class="col-6 mt-10">
        <button class="btn_help" routerLink="/contacto">¿Te ayudamos?</button>
      </div>
    </div>
  </div>
</section>